import { rolePermissions } from './config';

export const hasPermission = (role, permission) => {
  if (permission) {
    return rolePermissions[role]?.includes(permission);
  }
  return true;
};

export const hasOneOfPermissions = (role, permissions) => {
  if (Array.isArray(permissions)) {
    return permissions.some((permission) => rolePermissions[role]?.includes(permission));
  }
  return false;
};
